import { Col, Row } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router-dom'; // Import Link from react-router-dom
import './CandidateDashboard.css';
import DashboardLayout from './DashboardLayout';
import GlobalCandidateSettings from './GlobalCandidateSettings';


const Payment = () => {
  const navigate = useNavigate();
  const toggleSettings = () => {
    navigate('/');
  };
  const location = useLocation();
  const userName = location.state?.userName;
  const userId = location.state?.userId;

  return (
    <DashboardLayout>
      {/* <Row>
        <div className="text-center">
          <h4 style={{ color: 'purple' }}>Choose Your Plan</h4>
          <h1>Flexible Candidate Plans</h1>
          <p>Select the plan that best fits your job search needs</p>
        </div>
        <Col md={4}>
          <Card>
            <Card.Body>
              <Card.Title>Basic Candidate Plan</Card.Title>
              <Card.Text>
                <h3>$0.00(Free)</h3>
                <p>/month</p>
              </Card.Text>
              <Button variant="primary">Get Started</Button>
              <Card.Text className="mt-3">
                <p>Perfect for job seekers</p>
                <ul>
                  <li>Apply to up to 5 jobs per day</li>
                  <li>Email notifications</li>
                  <li>Access to job postings</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <Card.Body>
              <Card.Title>Premium Candidate Plan</Card.Title>
              <Card.Text>
                <h3>$9.99</h3>
                <p>/month</p>
              </Card.Text>
              <Button variant="primary">Get Started</Button>
              <Card.Text className="mt-3">
                <p>Great for serious job hunters</p>
                <ul>
                  <li>Apply to unlimited jobs</li>
                  <li>Resume optimization tips</li>
                  <li>Priority application review</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>

        <Col md={4}>
          <Card>
            <Card.Body>
              <Card.Title>Elite Candidate Plan</Card.Title>
              <Card.Text>
                <h3>$19.99</h3>
                <p>/month</p>
              </Card.Text>
              <Button variant="primary">Get Started</Button>
              <Card.Text className="mt-3">
                <p>Ideal for professionals seeking top jobs</p>
                <ul>
                  <li>One-on-one career coaching</li>
                  <li>Exclusive job postings</li>
                  <li>Profile visibility boost</li>
                </ul>
              </Card.Text>
            </Card.Body>
          </Card>
        </Col>
      </Row> */}
       <div className="main-content">
        <Row className="d-flex justify-content-between align-items-center" style={{ marginBottom: '20px' }}>
          <Col xs="auto">
            <h2 className='text-start' style={{ paddingLeft: '12px', marginBottom: 0 }}>Payment</h2>
          </Col>
          <Col xs="auto">
            <GlobalCandidateSettings userId={userId} />

          </Col>
        </Row>
      <section id="pricing" >
        <div className="container">
          <div className="mx-auto mb-[60px] max-w-[510px] text-center">
            <span className="mb-2 block text-lg font-semibold text-primary">
              Pricing section
            </span>
            <h2 className="mb-3 text-3xl font-bold text-dark dark:text-white sm:text-4xl md:text-[40px] md:leading-[1.2]">
              Awesome Pricing Plan
            </h2>
            <p className="text-base text-body-color dark:text-dark-6">
              We’re excited to offer free access during our launch phase to the first 10,000 job seekers and 5,000 companies.
              No charges, no commitments — just an opportunity to experience our platform at no cost.
            </p>
          </div>


          <div className="row justify-content-center">
            {/* Job Seekers Basic Plan */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow-sm border-light rounded-lg">
                <div className="card-body text-center">
                  <h5 className="card-title text-primary mb-4" style={{ fontSize: '1.5rem' }}>Job Seekers Basic</h5>
                  <h2 className="display-4 font-weight-bold text-dark" style={{ fontSize: '3rem' }}>
                    <span className="text-xl" style={{ fontSize: '2rem' }}>$</span>
                    <span className="text-muted" style={{ fontSize: '3rem' }}>Free</span>
                  </h2>
                  <ul className="list-unstyled mt-4">
                    <li><strong>✔</strong> Dream Company Apply</li>
                    <li><strong>✔</strong> Multi-resume profiles</li>
                    <li><strong>✔</strong> Job preference personalization</li>
                    <li><strong>✔</strong> AI matches</li>
                    <li><strong>✔</strong> Stealth Profile (Free for limited time)</li>
                    <li><strong>✔</strong> Basic Resume analytics</li>
                  </ul>
                  <a href="javascript:void(0)" className="btn btn-primary mt-3 px-5 py-2">Join Now</a>
                </div>
              </div>
            </div>

            {/* Corporate Basic Plan (Recommended) */}
            {/* <div className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow-sm border-light rounded-lg">
                <div className="card-body text-center position-relative">
                  <span
                    className="badge badge-primary position-absolute"
                    style={{ top: '20px', right: '-60px', transform: 'rotate(90deg)' }}
                  >
                    Recommended
                  </span>
                  <h5 className="card-title text-primary mb-4" style={{ fontSize: '1.5rem' }}>Corporate Basic</h5>
                  <h2 className="display-4 font-weight-bold text-dark" style={{ fontSize: '3rem' }}>
                    <span className="text-xl" style={{ fontSize: '2rem' }}>$</span>
                    <span className="text-muted" style={{ fontSize: '3rem' }}>Free</span>
                  </h2>
                  <ul className="list-unstyled mt-4">
                    <li><strong>✔</strong> Free easy to access shared but secured Jobbox</li>
                    <li><strong>✔</strong> Your own data bank</li>
                    <li><strong>✔</strong> 10 HR accounts free</li>
                    <li><strong>✔</strong> Unlimited job posts</li>
                    <li><strong>✔</strong> Stealth profile connects</li>
                    <li><strong>✔</strong> Direct candidate connect</li>
                    <li><strong>✔</strong> Choose from seekers who Dream about joining you</li>
                    <li><strong>✔</strong> Evergreen jobs- profiles you are always looking to hire</li>
                  </ul>
                  <a href="javascript:void(0)" className="btn btn-primary mt-3 px-5 py-2">Open/Claim your Jobbox</a>
                </div>
              </div>
            </div> */}

            {/* Premium Plan (Coming Soon) */}
            <div className="col-lg-4 col-md-6 mb-4">
              <div className="card shadow-sm border-light rounded-lg">
                <div className="card-body text-center">
                  <h5 className="card-title text-primary mb-4" style={{ fontSize: '1.5rem' }}>Premium</h5>
                  <h2 className="display-4 font-weight-bold text-dark" style={{ fontSize: '3rem' }}>
                    <span className="text-xl" style={{ fontSize: '2rem' }}>$</span>
                    <span className="text-muted" style={{ fontSize: '3rem' }}>Coming soon</span>
                  </h2>
                  <ul className="list-unstyled mt-4">
                    <li><strong>✔</strong> Seeker-Pro - Credits to apply to more companies</li>
                    <li><strong>✔</strong> Advanced resume analytics</li>
                    <li><strong>✔</strong> Hr-Pro - Advanced Analytics</li>
                    <li><strong>✔</strong> Stealth hunting</li>
                    <li><strong>✔</strong> AI matches (Coming soon)</li>
                  </ul>
                  <a href="javascript:void(0)" className="btn btn-secondary mt-3 px-5 py-2 disabled">Coming soon</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      </div>
    </DashboardLayout>
  );
};

export default Payment;
